const headerStyle = () => {
    return {
        borderColor: '#a81933'
    };
};

export const columns = [
    {
        dataField: 'productName',
        text: 'Subscription Name',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'productTypeName',
        text: 'Subscription Type',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'netsuiteItem',
        text: 'Corp Netsuite Item',
        sort: true,
        headerStyle: headerStyle
    },
    {
        dataField: 'netsuiteNonCorpItem',
        text: 'NonCorp Netsuite Item',
        sort: true,
        headerStyle: headerStyle
    },
];

export const sorting = [{
    dataField: 'productName',
    order: 'asc'
}];